import { buttonStyle } from 'components/buttons/buttonStyle';
import { Button } from 'components/ui/button';
import { ModalActions } from 'components/modals/useModal';
import { Control, UseFormSetValue, useWatch } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { AffiliationForm, EmployeeForm } from 'types/employees';
import AffiliationModal from './AffiliationModal';

export enum Position {
    SECTION_SIDE,
    HISTORY_SIDE,
}

interface Props {
    position: Position;
    control: Control<EmployeeForm>;
    setValue: UseFormSetValue<EmployeeForm>;
    modalActions: ModalActions;
}

const defaultInitialData: AffiliationForm = {
    partyEmployeeId: null,
    party: null,
    notes: '',
    error: false,
};

const AddAffiliationButton = ({ control, setValue, position, modalActions }: Props) => {
    const affiliations = useWatch({ control, name: `affiliations` });

    const shouldBeDisplayed =
        position === Position.SECTION_SIDE ? affiliations.length !== 0 : affiliations.length === 0;

    if (!shouldBeDisplayed) {
        return null;
    }

    const addAffiliation = (newAffiliation: AffiliationForm) => {
        setValue('affiliations', [...affiliations, newAffiliation]);
    };

    const openAffiliationModal = () =>
        modalActions.openModal(
            <AffiliationModal
                onClose={modalActions.closeModal}
                onSave={addAffiliation}
                initialData={{ ...defaultInitialData }}
                titleId={'employees.affiliations.form.add-title'}
            />
        );

    const variant = position === Position.SECTION_SIDE ? 'outlined' : 'contained';
    const color = position === Position.SECTION_SIDE ? 'primary' : 'secondary';
    return (
        <Button {...buttonStyle({ variant, color, size: 'small' }, 'ml-3')} onClick={openAffiliationModal}>
            <FormattedMessage id="employees.affiliations.add" />
        </Button>
    );
};

export default AddAffiliationButton;
